import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { containerImageService } from '~/services/workspaceAPI';
import {
  formatErrorPayload,
  UseApiQueryOptions,
  useCurrentWorkspaceQueryKey,
  validateApiResponse,
} from '../utils';

const ROOT_KEY = 'images';
const getRootQueryKey = () => [ROOT_KEY];

export const useImagesQuery = (
  options?: UseApiQueryOptions<typeof containerImageService.getAll>,
) => {
  const dispatch = useDispatch();
  const { workspaceId } = useCurrentWorkspaceQueryKey();

  const queryKey = getRootQueryKey();
  return useQuery(
    queryKey,
    async () => validateApiResponse(await containerImageService.getAll({ workspaceId })).data,
    {
      onError: (error) => dispatch(formatErrorPayload(error)),
      ...options,
    },
  );
};
